import { render, staticRenderFns } from "./ITAdminAudit.vue?vue&type=template&id=c71e4d50&scoped=true"
import script from "./ITAdminAudit.vue?vue&type=script&lang=js"
export * from "./ITAdminAudit.vue?vue&type=script&lang=js"
import style0 from "./ITAdminAudit.vue?vue&type=style&index=0&id=c71e4d50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71e4d50",
  null
  
)

export default component.exports